module.exports = __webpack_public_path__ + "img/Iola.e5e38c44.png";